const translation = {
  site: {
    name: '漫画之家',
    tagline: '韩国免费漫画 · 下拉式韩漫大全 · 韩漫在线阅读',
    description: '在漫画之家，您能免费阅读下拉式韩漫大全，在线浏览各种韩国漫画，体验流畅的阅读服务，轻松探索人气作品并随时追更喜爱故事内容。',
  },
  nav: {
    home: '首页',
    category: '分类',
    about: '关于我们',
    search: '搜索漫画...',
  },
  home: {
    heroTitle: '畅享韩国漫画',
    heroSubtitle: '免费阅读海量优质韩漫，下拉式流畅体验，随时随地追更你爱的故事',
    heroCta: '开始阅读',
    hotTitle: '热门推荐',
    hotDesc: '大家都在看的韩漫作品',
    categoryTitle: '漫画分类',
    categoryDesc: '按喜好找到属于你的漫画世界',
    latestTitle: '最近更新',
    latestDesc: '追更不停歇，精彩不等待',
    ctaTitle: '准备好开始你的漫画之旅了吗？',
    ctaDesc: '加入数百万读者，免费畅享海量韩国漫画',
    ctaButton: '立即免费阅读',
    viewAll: '查看全部',
  },
  comic: {
    status: '状态',
    author: '作者',
    rating: '评分',
    views: '阅读量',
    updateDate: '更新日期',
    chapters: '章节列表',
    description: '作品简介',
    tags: '标签',
    relatedTitle: '同类推荐',
    readNow: '开始阅读',
    chapterPrefix: '第',
    chapterText: '话',
    completed: '已完结',
    ongoing: '连载中',
  },
  category: {
    title: '漫画分类',
    desc: '选择你喜欢的类型，发现更多精彩韩漫',
    allCategories: '全部分类',
    resultCount: '共 {{count}} 部作品',
    empty: '暂无该分类下的漫画，看看其他分类吧~',
  },
  about: {
    title: '关于漫画之家',
    brandTitle: '品牌故事',
    brandDesc: '漫画之家成立于2020年，致力于为广大中文读者提供最优质的韩国漫画阅读体验。我们与韩国多家知名漫画平台合作，拥有海量正版韩漫资源。',
    missionTitle: '我们的使命',
    missionDesc: '让每一位漫画爱好者都能轻松、便捷地阅读到最新、最热的韩国漫画。我们坚持免费阅读的理念，通过优质的用户体验和丰富的内容库，打造中文世界最受欢迎的韩漫平台。',
    repoTitle: '用户口碑',
    repoDesc: '听听我们的读者怎么说',
    contactTitle: '联系我们',
    contactDesc: '如有任何问题或建议，欢迎随时与我们联系',
    email: '电子邮箱',
    phone: '联系电话',
    address: '公司地址',
    addressValue: '上海市浦东新区张江高科技园区漫画之家大厦1001室',
    emailValue: 'contact@manhuazhijia.com',
    phoneValue: '+86 400-888-6666',
    workingHours: '工作时间',
    workingHoursValue: '周一至周五 9:00 - 18:00',
    socialTitle: '关注我们',
    reviews: [
      {
        name: '小林',
        avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20person%20avatar%20portrait%20simple%20clean%20background%20friendly%20smile%20professional%20headshot%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
        rating: 5,
        comment: '漫画之家真的是我找到的最好的韩漫平台！更新速度快，画质清晰，而且全部免费，强烈推荐给喜欢韩漫的朋友们！',
      },
      {
        name: '阿杰',
        avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20male%20avatar%20portrait%20simple%20clean%20background%20casual%20style%20friendly%20expression&width=100&height=100&seq=avatar-02&orientation=squarish',
        rating: 5,
        comment: '下拉式阅读体验太棒了！比一页页翻方便太多了，现在已经是我每天通勤必看的应用。希望平台越来越好！',
      },
      {
        name: '小美',
        avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20female%20avatar%20portrait%20simple%20clean%20background%20warm%20smile%20natural%20look&width=100&height=100&seq=avatar-03&orientation=squarish',
        rating: 5,
        comment: '分类很全，想看的韩漫基本都能找到。页面设计也很简洁舒服，没有乱七八糟的广告，阅读体验特别流畅！',
      },
    ],
  },
  footer: {
    copyright: '© 2026 漫画之家 ManhuaZhijia.com 保留所有权利',
    quickLinks: '快速链接',
    categories: '漫画分类',
    support: '帮助支持',
    about: '关于我们',
    contact: '联系我们',
    feedback: '意见反馈',
    help: '帮助中心',
    privacy: '隐私政策',
    terms: '服务条款',
    follow: '关注我们',
  },
  breadcrumb: {
    home: '首页',
    category: '分类',
    article: '漫画详情',
    about: '关于我们',
  },
};

export default translation;